import { ExternalLinkIcon } from '@radix-ui/react-icons';
import { FC, ReactNode } from 'react';
import { Link } from 'react-router';

import styles from './nav-menu-item.module.scss';

interface NavMenuItemProps {
  to: string;
  label?: string;
  icon?: ReactNode;
  isActive?: boolean;

  /**
   * Render the item as an external link that opens in a new tab and shows
   * an external-link indicator on the right instead of routing internally.
   */
  external?: boolean;

  /**
   * Additional actions that can be triggered when a link is selected
   * i.g. to close a drawer or change a state value on navigation
   */
  onClick?: () => void;

  /**
   * React router state to pass around during navigation
   */
  state?: object;
}

export const NavMenuItem: FC<NavMenuItemProps> = ({
  to,
  label,
  icon,
  onClick,
  isActive,
  state,
  external,
}) => {
  if (external) {
    return (
      <a
        className={styles['menu-item']}
        onClick={onClick}
        href={to}
        target="_blank"
        rel="noopener noreferrer"
      >
        {icon} <span>{label}</span>
        <ExternalLinkIcon className={styles['external-icon']} />
      </a>
    );
  }

  return (
    <Link className={styles['menu-item']} onClick={onClick} to={to} data-is-active={isActive} state={state}>
      {icon} <span>{label}</span>
    </Link>
  );
};
